export default __webpack_public_path__ + "static/media/shelder.3f0c27b5.png";